import { BlokItem, DynamicRender, sbEditable, SBProps } from '../../../utils';

interface SBPageProps {
  body?: BlokItem[];
  advancedSeo: BlokItem[];
  parentProps?: Record<string, string>;
}

export const SBPage = ({ blok }: SBProps<SBPageProps>) => {
  const { body, advancedSeo, parentProps } = blok;

  return (
    <main {...sbEditable(blok)}>
      {advancedSeo && <DynamicRender data={advancedSeo} parentProps={parentProps} />}
      <DynamicRender data={body} parentProps={parentProps} />
    </main>
  );
};
